import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ProtectedUserRoute = ({ component: Component, allowed, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) =>
                allowed ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/u/dashboard',
                        }}
                    />
                )
            }
        />
    );
};

export default ProtectedUserRoute;